<div
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold" i18n="@@adminProductInfoTitle">Product Info</h2>
  </div>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-3">
    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold tracking-wider uppercase">
        {{ isArabic() ? "فئة الصنف" : "Product Category" }}
      </span>
      <span class="valueColor">
        {{ category() }}
      </span>
    </div>

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold tracking-wider uppercase" i18n="@@product.field.mfgCompany">
        Manufacturing Company
      </span>
      <span class="valueColor">
        {{ mfgCompany() }}
      </span>
    </div>

    @if (batchNumber()) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold tracking-wider uppercase" i18n="@@batchNumber">Batch Number</span>
        <span class="valueColor">
          {{ batchNumber() }}
        </span>
      </div>
    }

    @if (subCategory()) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold tracking-wider uppercase">
          {{ isArabic() ? "فئة فرعية" : "Sub Category" }}
        </span>
        <span class="valueColor">
          {{ subCategory() }}
        </span>
      </div>
    }

    @if (mfgDate()) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold tracking-wider uppercase">
          {{ isArabic() ? "تاريخ الانتاج" : "Manufacturing Date" }}
        </span>
        <span class="valueColor">
          {{ mfgDate() }}
        </span>
      </div>
    }

    @if (expDate()) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold tracking-wider uppercase">
          {{ isArabic() ? "تاريخ الانتهاء" : "Expiry Date" }}
        </span>
        <span class="valueColor">
          {{ expDate() }}
        </span>
      </div>
    }

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold tracking-wider uppercase">
        {{ isArabic() ? "سعر الجمهور" : "People Price" }}
      </span>

      <div class="flex items-baseline gap-2 whitespace-nowrap">
        <span class="valueColor font-semibold">
          {{ peoplePrice() }}
          <span class="text-xs font-medium text-gray-900">
            {{ isArabic() ? "ج.م" : "EGP" }}
          </span>
        </span>
      </div>
    </div>

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold tracking-wider uppercase">
        {{ isArabic() ? "سعر الصيدلية" : "Pharmacy Price" }}
      </span>

      <div class="flex items-baseline gap-2 whitespace-nowrap">
        <span class="valueColor font-semibold">
          {{ pharmacyPrice() }}
          <span class="text-xs font-medium text-gray-900">
            {{ isArabic() ? "ج.م" : "EGP" }}
          </span>
        </span>

        @if (businessPriceDiscountPercentage()) {
          <span class="text-xs font-semibold text-green-600">({{ businessPriceDiscountPercentage() }}%)</span>
        }
      </div>
    </div>

    @if (description()) {
      <div class="col-span-1 flex flex-col gap-1.5 border-t border-gray-50 pt-3 md:col-span-3">
        <span class="grayColor font-bold">
          {{ isArabic() ? "الوصف" : "Description" }}
        </span>

        <p class="valueColor max-w-3xl text-[13px] leading-[1.5] font-medium">
          {{ description() }}
        </p>
      </div>
    }
  </div>
</div>
